export default {
      id: "ic-plan-enfance-alt-bis-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-enfance-alt-bis-usage",
      toString: function () {
        return this.url;
      }
    }